import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  hasAtLeastLetterOrNumber,
  isStringNotEmptyAndTrimmed,
  isStringNullOrEmpty,
} from '@wz-utilities/string.utilities';

export class WzValidators {
  static conditionalRequired(checkFunc: () => boolean): ValidatorFn {
    return this.conditional(checkFunc, Validators.required);
  }

  static filter(validationFunc: () => boolean, errKey: string): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value) {
        if (!validationFunc()) {
          return {
            [errKey]: true,
          };
        }
      }

      return null;
    };
  }

  static conditional(
    checkFunc: () => boolean,
    ...validatorFn: ValidatorFn[]
  ): ValidatorFn | any {
    return (ctrl: AbstractControl) => {
      if (checkFunc()) {
        const composed = Validators.compose([...validatorFn]);
        return composed ? composed(ctrl) : null;
      }

      return null;
    };
  }

  static atLeastOneRequired(
    firstControlName: string,
    secondControlName: string,
  ): ValidatorFn | any {
    return (group: FormGroup) => {
      const firstCtrl = group.get(firstControlName);
      const secondCtrl = group.get(secondControlName);

      if (
        isStringNullOrEmpty(firstCtrl?.value) &&
        isStringNullOrEmpty(secondCtrl?.value)
      ) {
        firstCtrl?.setErrors({ atleastonerequired: true });
        secondCtrl?.setErrors({ atleastonerequired: true });
        return { atleastonerequired: true };
      } else {
        if (firstCtrl?.errors) {
          delete firstCtrl.errors['atleastonerequired'];
          if (Object.keys(firstCtrl.errors).length === 0) {
            firstCtrl.setErrors(null);
          }
        }
        if (secondCtrl?.errors) {
          delete secondCtrl.errors['atleastonerequired'];
          if (Object.keys(secondCtrl.errors).length === 0) {
            secondCtrl.setErrors(null);
          }
        }
      }

      return null;
    };
  }

  static stringNotEmptyAndTrimmed(
    ctrl: AbstractControl,
  ): ValidationErrors | null {
    if (!isStringNotEmptyAndTrimmed(ctrl.value)) {
      return {
        stringNotEmptyAndTrimmed: true,
      };
    }
    return null;
  }

  static atLeastOneLetterRequired(
    ctrl: AbstractControl,
  ): ValidationErrors | null {
    if (!hasAtLeastLetterOrNumber(ctrl.value)) {
      return {
        atLeastOneLetterRequired: true,
      };
    }
    return null;
  }
}
